<template>
  <section class="testimonials-section">
    <div class="testimonials-header">
      <h2 class="testimonials-title">Trusted by travelers worldwide</h2>
      <p class="testimonials-description">
        Join thousands of adventurers who are <br />already exploring the world
        with our travel platform
      </p>
    </div>

    <div class="testimonials-container">
      <div class="gradient-left"></div>
      <div class="testimonials-track">
        <!-- First set of testimonials -->
        <div class="testimonial-card">
          <div class="testimonial-header">
            <div class="testimonial-avatar">
              <img
                src="https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=150&h=150&fit=crop&crop=face"
                alt=""
              />
            </div>
            <div class="testimonial-author">
              <span class="author-name">Sarah Chen</span>
              <span class="author-handle">@wanderlust_sarah</span>
            </div>
          </div>
          <p class="testimonial-text">
            This app made planning my Europe trip so much easier! The AI
            suggestions for daily itineraries were spot-on and saved me hours of
            research.
          </p>
        </div>

        <div class="testimonial-card">
          <div class="testimonial-header">
            <div class="testimonial-avatar">
              <img
                src="https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=150&h=150&fit=crop&crop=face"
                alt=""
              />
            </div>
            <div class="testimonial-author">
              <span class="author-name">Emily Walker</span>
              <span class="author-handle">@travelwithemily</span>
            </div>
          </div>
          <p class="testimonial-text">
            Love how easy it is to share trip plans with friends! We planned our
            entire group vacation to Italy without a single confusing email
            thread.
          </p>
        </div>

        <div class="testimonial-card">
          <div class="testimonial-header">
            <div class="testimonial-avatar">
              <img
                src="https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face"
                alt=""
              />
            </div>
            <div class="testimonial-author">
              <span class="author-name">James Mitchell</span>
              <span class="author-handle">@adventurejames</span>
            </div>
          </div>
          <p class="testimonial-text">
            The budget tracking feature is a game-changer! Finally found an app
            that helps me plan amazing trips while keeping costs under control.
          </p>
        </div>

        <!-- Duplicate set for infinite scroll -->
        <div class="testimonial-card">
          <div class="testimonial-header">
            <div class="testimonial-avatar">
              <img
                src="https://images.unsplash.com/photo-1534528741775-53994a69daeb?w=150&h=150&fit=crop&crop=face"
                alt=""
              />
            </div>
            <div class="testimonial-author">
              <span class="author-name">Sarah Chen</span>
              <span class="author-handle">@wanderlust_sarah</span>
            </div>
          </div>
          <p class="testimonial-text">
            This app made planning my Europe trip so much easier! The AI
            suggestions for daily itineraries were spot-on and saved me hours of
            research.
          </p>
        </div>

        <div class="testimonial-card">
          <div class="testimonial-header">
            <div class="testimonial-avatar">
              <img
                src="https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=150&h=150&fit=crop&crop=face"
                alt=""
              />
            </div>
            <div class="testimonial-author">
              <span class="author-name">Emily Walker</span>
              <span class="author-handle">@travelwithemily</span>
            </div>
          </div>
          <p class="testimonial-text">
            Love how easy it is to share trip plans with friends! We planned our
            entire group vacation to Italy without a single confusing email
            thread.
          </p>
        </div>

        <div class="testimonial-card">
          <div class="testimonial-header">
            <div class="testimonial-avatar">
              <img
                src="https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face"
                alt=""
              />
            </div>
            <div class="testimonial-author">
              <span class="author-name">James Mitchell</span>
              <span class="author-handle">@adventurejames</span>
            </div>
          </div>
          <p class="testimonial-text">
            Finally found an app that helps me plan amazing trips while keeping
            costs under control.
          </p>
        </div>
      </div>
      <div class="gradient-right"></div>
    </div>
  </section>
</template>

<script>
export default {
  name: "TestimonialsSection",
};
</script>
